export default [
  'clickLearnMore',
  'clickUpgrade',
  'closeModal',
  'showModal'
]
